/* eslint-disable camelcase */
import { decompressValue } from "./decompressValue";
import { isCompressedPusherResponse } from "./types";

/*
 * Inflates gzipped pusher response attributes. Requires response of the format:
 * {
 *   :is_compressed => true,
 *   :compressed_payload => <base64 encoded binary data>
 * }
 *
 * Returns the same object, inflated and stripped of the compression flag:
 * {
 *   :<attr1> => <original value>,
 *   :<attr2> => <original value>,
 *   ...
 * }
 */
export const decompressPusherResponseV2 = <Result>(response: unknown): unknown => {
  if (isCompressedPusherResponse(response)) {
    return decompressValue<Result>(response.compressed_payload);
  }
  return response;
};
